import React from 'react';
import { CoffeeIcon, SparklesIcon, BrushIcon, PillIcon, TimerIcon, SaladIcon, CupSodaIcon, CarrotIcon, BeakerIcon, AppleIcon, ChevronRightIcon } from 'lucide-react';
interface ToolsScreenProps {
  openModal: (id: string) => void;
}
export function ToolsScreen({
  openModal
}: ToolsScreenProps) {
  return <div className="flex flex-col min-h-screen pb-24 animate-fade-in" data-id="element-282">
      <div className="bg-gradient-to-br from-[#3A2010] via-[#6A4020] to-[#9A7050] px-5 pt-6 pb-8" data-id="element-283">
        <div className="text-white/70 text-[13px] mb-1" data-id="element-284">Your Arsenal</div>
        <div className="text-white text-2xl font-extrabold mb-1.5" data-id="element-285">
          Tools & Techniques
        </div>
        <div className="text-white/70 text-sm" data-id="element-286">
          Everything you need to activate flow
        </div>
      </div>

      <div className="px-5 py-4 grid grid-cols-2 gap-3.5" data-id="element-287">
        <div className="col-span-2 bg-gradient-to-br from-[#2C4A30] to-[#4A7A50] text-white rounded-[18px] p-[18px] px-4 flex items-center gap-4 cursor-pointer shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.97]" onClick={() => openModal('bitter')} data-id="element-288">
          <CoffeeIcon className="w-9 h-9 shrink-0" data-id="element-289" />
          <div data-id="element-290">
            <div className="text-sm font-bold mb-1" data-id="element-291">Warm Bitter Ritual</div>
            <div className="text-xs text-white/75" data-id="element-292">
              30-sec morning protocol. Doubles liver efficiency in 48 hrs.
            </div>
          </div>
        </div>

        <div className="bg-white rounded-[18px] p-[18px] px-4 text-center cursor-pointer shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.97]" onClick={() => openModal('lymph')} data-id="element-293">
          <SparklesIcon className="w-9 h-9 text-teal mx-auto mb-2.5" data-id="element-294" />
          <div className="text-sm font-bold text-text-dark mb-1" data-id="element-295">
            3-Point Press
          </div>
          <div className="text-xs text-text-light" data-id="element-296">2-min lymph technique</div>
        </div>

        <div className="bg-white rounded-[18px] p-[18px] px-4 text-center cursor-pointer shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.97]" onClick={() => openModal('brush')} data-id="element-297">
          <BrushIcon className="w-9 h-9 text-orange-700 mx-auto mb-2.5" data-id="element-298" />
          <div className="text-sm font-bold text-text-dark mb-1" data-id="element-299">
            Dry Brushing
          </div>
          <div className="text-xs text-text-light" data-id="element-300">
            Skin emunctory activation
          </div>
        </div>

        <div className="bg-white rounded-[18px] p-[18px] px-4 text-center cursor-pointer shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.97]" onClick={() => openModal('mag')} data-id="element-301">
          <PillIcon className="w-9 h-9 text-blue-700 mx-auto mb-2.5" data-id="element-302" />
          <div className="text-sm font-bold text-text-dark mb-1" data-id="element-303">
            Mag-Potassium Ratio
          </div>
          <div className="text-xs text-text-light" data-id="element-304">Mineral flush protocol</div>
        </div>

        <div className="bg-white rounded-[18px] p-[18px] px-4 text-center cursor-pointer shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.97]" onClick={() => openModal('timer')} data-id="element-305">
          <TimerIcon className="w-9 h-9 text-sage-dark mx-auto mb-2.5" data-id="element-306" />
          <div className="text-sm font-bold text-text-dark mb-1" data-id="element-307">
            Ritual Timer
          </div>
          <div className="text-xs text-text-light" data-id="element-308">Guided countdown</div>
        </div>
      </div>

      <div className="px-5 pt-1 pb-2.5" data-id="element-309">
        <div className="text-lg font-bold text-text-dark" data-id="element-310">
          Drainage Meal Plan
        </div>
      </div>

      <div className="px-5 flex flex-col gap-2.5 mb-5" data-id="element-311">
        <div className="bg-white rounded-2xl p-4 px-[18px] flex items-center gap-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] cursor-pointer" onClick={() => openModal('recipe1')} data-id="element-312">
          <SaladIcon className="w-8 h-8 text-sage-dark shrink-0" data-id="element-313" />
          <div className="flex-1" data-id="element-314">
            <div className="text-[15px] font-bold text-text-dark" data-id="element-315">
              Liver Greens Bowl
            </div>
            <div className="text-xs text-text-light mt-0.5" data-id="element-316">
              Lunch · 15 min · High sulfur · Anti-bloat
            </div>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-text-light" data-id="element-317" />
        </div>

        <div className="bg-white rounded-2xl p-4 px-[18px] flex items-center gap-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] cursor-pointer" onClick={() => openModal('recipe2')} data-id="element-318">
          <CupSodaIcon className="w-8 h-8 text-orange-700 shrink-0" data-id="element-319" />
          <div className="flex-1" data-id="element-320">
            <div className="text-[15px] font-bold text-text-dark" data-id="element-321">
              Bitter Ginger Tonic
            </div>
            <div className="text-xs text-text-light mt-0.5" data-id="element-322">
              Morning · 5 min · Liver activator · Anti-inflammatory
            </div>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-text-light" data-id="element-323" />
        </div>

        <div className="bg-white rounded-2xl p-4 px-[18px] flex items-center gap-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] cursor-pointer" onClick={() => openModal('recipe3')} data-id="element-324">
          <CarrotIcon className="w-8 h-8 text-blue-700 shrink-0" data-id="element-325" />
          <div className="flex-1" data-id="element-326">
            <div className="text-[15px] font-bold text-text-dark" data-id="element-327">
              Sulfur Detox Plate
            </div>
            <div className="text-xs text-text-light mt-0.5" data-id="element-328">
              Dinner · 20 min · Liver Phase II · Gut health
            </div>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-text-light" data-id="element-329" />
        </div>

        <div className="bg-white rounded-2xl p-4 px-[18px] flex items-center gap-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] cursor-pointer" onClick={() => openModal('mag')} data-id="element-330">
          <BeakerIcon className="w-8 h-8 text-yellow-700 shrink-0" data-id="element-331" />
          <div className="flex-1" data-id="element-332">
            <div className="text-[15px] font-bold text-text-dark" data-id="element-333">
              Mag-Potassium Night Drink
            </div>
            <div className="text-xs text-text-light mt-0.5" data-id="element-334">
              Evening · 2 min · Mineral balance · Colon flush
            </div>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-text-light" data-id="element-335" />
        </div>

        <div className="bg-white rounded-2xl p-4 px-[18px] flex items-center gap-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] cursor-pointer" data-id="element-336">
          <AppleIcon className="w-8 h-8 text-green-600 shrink-0" data-id="element-337" />
          <div className="flex-1" data-id="element-338">
            <div className="text-[15px] font-bold text-text-dark" data-id="element-339">
              Grab & Go Office Bowl
            </div>
            <div className="text-xs text-text-light mt-0.5" data-id="element-340">
              Prep Sunday · Keeps 4 days · Anti-stagnation
            </div>
          </div>
          <ChevronRightIcon className="w-5 h-5 text-text-light" data-id="element-341" />
        </div>
      </div>
    </div>;
}